//@ts-nocheck
import React, { FC } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import { ActivityLogType, InsightDay } from "../../DTO";
import {
    formatDuration,
    patientDateKey,
} from "../../utils/health-report-format";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const ReportActivityChart: FC<{
    activity: ActivityLogType[];
    days?: InsightDay[];
}> = ({ activity, days }) => {
    const byDate = new Map(
        activity.map((item) => [
            patientDateKey(item.createdAt, item.timezoneOffset),
            item,
        ]),
    );
    const chartDays = days?.length
        ? days
        : activity.map((item) => ({
              date: patientDateKey(item.createdAt, item.timezoneOffset),
              name: new Date(item.createdAt).toLocaleDateString(undefined, {
                  weekday: "short",
              }),
          }));
    const dataPoints = chartDays.map((day) => {
        const item = byDate.get(day.date);
        return {
            label: day.name.slice(0, 3),
            date: day.date,
            y: item ? Number(item.totalSteps || 0) : null,
            duration: item
                ? formatDuration(item.totalDurationTime)
                : "No activity recorded",
        };
    });
    const recorded = dataPoints.filter((point) => point.y !== null);
    const average = recorded.length
        ? Math.round(
              recorded.reduce((sum, point) => sum + point.y, 0) /
                  recorded.length,
          )
        : null;

    return (
        <section className="health-chart-panel">
            <header>
                <div>
                    <span>Weekly pattern</span>
                    <h2>Daily steps</h2>
                </div>
                <p>
                    {average === null
                        ? "No recorded days"
                        : `${average.toLocaleString()} average steps on recorded days`}
                </p>
            </header>
            <CanvasJSChart
                options={{
                    animationEnabled: false,
                    backgroundColor: "transparent",
                    height: 320,
                    axisX: {
                        lineColor: "#d0d5dd",
                        tickColor: "#d0d5dd",
                        labelFontColor: "#475467",
                    },
                    axisY: {
                        includeZero: true,
                        gridColor: "#eef1f4",
                        lineThickness: 0,
                        tickLength: 0,
                        labelFontColor: "#667085",
                        title: "Steps",
                    },
                    toolTip: { cornerRadius: 6 },
                    data: [
                        {
                            type: "column",
                            color: "#4f7c82",
                            toolTipContent:
                                "<strong>{label}, {date}</strong><br/>{y} steps<br/>{duration}",
                            dataPoints,
                        },
                    ],
                }}
            />
            <p className="health-chart-note">
                Blank days mean no activity was recorded. They are not included
                in the average.
            </p>
        </section>
    );
};
